import { render } from "./guide.vue?vue&type=template&id=89cab9d2&scoped=true"
import script from "./guide.vue?vue&type=script&lang=js"
export * from "./guide.vue?vue&type=script&lang=js"

import "./guide.vue?vue&type=style&index=0&id=89cab9d2&scoped=true&lang=css"

import exportComponent from "D:\\CLionProjects\\vue_phone\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89cab9d2"]])

export default __exports__